import signIn from "app/api/requests/Auth/signInRequest";
import signUp from "app/api/requests/Auth/signUpRequest";

export default {
  signIn,
  signUp
};
